/** Rótulo amigável para listagens admin (perfis/grupos), distinguindo dashboards de área. */
export function resolveAdminModuleLabel(name: string, pillar?: string | null): string {
  const trimmedName = name.trim();
  const trimmedPillar = pillar?.trim() ?? '';

  if (!trimmedPillar) {
    return trimmedName;
  }

  if (trimmedName === 'Visão geral') {
    return `Visão geral — ${trimmedPillar}`;
  }

  return trimmedName;
}
